import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
	data: [],
	loading: false,
};

const getRolesStart = (state) => {
	return updateObject(state, { loading: true });
};

const getRolesSuccess = (state, action) => {
	return updateObject(state, { data: action.data, loading: false });
};

const clearRoles = () => {
	return initialState;
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.GET_ROLES_START:
			return getRolesStart(state, action);
		case actionTypes.GET_ROLES_SUCCESS:
			return getRolesSuccess(state, action);

		case actionTypes.CLEAN_ROLES:
			return clearRoles(state, action);

		default:
			return state;
	}
};

export default reducer;
